module.exports = "<div class=\"alert alert-danger alert-dismissible fade show\" role=\"alert\" *ngIf=\"error\">\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"error = null\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n  <strong>{{ error.message }}</strong>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/display/error-alert/error-alert.component.html
// module id = 1154
// module chunks = 0